export default __webpack_public_path__ + "media/4a5e3ea79b19ad32249c573082396dd060a984c84468d96bf91e1cb224b1d3db.svg";